import { LayoutType } from "react-photo-album";

type HomeGlobeCardType = "interactive" | "animated";

export interface Settings {
    photoAlbum_layout: LayoutType;
    photoAlbum_targetRowHeight: number;
    photoAlbum_roundedBorder: boolean;
    photoAlbum_spacing: number;
    slideshow_delay: number;
    home_globeCard_type: HomeGlobeCardType;
    gallery_thumbnailHoverEffect: boolean;
}

export const SETTINGS_DEFAULTS: Settings = {
    photoAlbum_layout: "rows",
    photoAlbum_targetRowHeight: 200,
    photoAlbum_roundedBorder: true,
    photoAlbum_spacing: 4,
    slideshow_delay: 5000,
    home_globeCard_type: "animated",
    gallery_thumbnailHoverEffect: false,
};